import { onDomReady } from "../services/on-dom-ready";
import ModalBlocked from "../components/modal/modal-blocked";

const confirmPopupPromise = new Promise((resolve, reject) => {
  onDomReady.then(() => {
    let element = document.getElementById("confirm");
    if (element) {
      let popup = ModalBlocked.get(element);
      resolve(popup);
    } else {
      reject("There is no #confirm element on page");
    }
  });
});

const confirm = ({ question, confirmText } = {}) => {
  return new Promise((resolve, reject) => {
    confirmPopupPromise
      .then(popup => {
        let confirmButton = popup.root.querySelector('[data-confirm-button]');
        let confirmed = false;

        if (confirmText) {
          confirmButton.innerHTML = confirmText;
        }
        
        if (question) {
          let text = popup.root.querySelector('[data-confirm-question]');
          text.innerHTML = question;
        }

        const onSuccess = () => {
          console.log('on success test')
          confirmed = true;
          popup.close();
          resolve();
        }

        confirmButton.addEventListener('click', onSuccess);

        console.log(ModalBlocked.events)

        popup.root.addEventListener(ModalBlocked.events.closed, () => {
          if (!confirmed) reject();
          confirmButton.removeEventListener('click', onSuccess);
        }, { once: true });

        popup.open();
      })
      .catch(error => reject(error));
  })
}

export { confirm };